import React, { useState, FunctionComponent, useEffect } from 'react';
import { Presentation } from './presentation';
import { useAdjustableDays } from '../../../hooks/useAdjustableDays';

type Props = {
  birthday: string;
  onChangedBody: (name: string, value: string) => void;
  target: string;
};

export const Component: FunctionComponent<Props> = ({
  birthday,
  onChangedBody,
  target,
}) => {
  const [year, setYear] = useState<string>('');
  const [month, setMonth] = useState<string>('');
  const [day, setDay] = useState<string>('');

  const { dayOptions, correctedDay } = useAdjustableDays({ year, month, day });

  useEffect(() => {
    if (birthday) {
      const [y, m, d] = birthday
        .replace('年', '-')
        .replace('月', '-')
        .replace('日', '')
        .split('-')
        .map((v) => v.trim());
      setYear(y);
      setMonth(String(Number(m)));
      setDay(String(Number(d)));
    } else {
      setYear('');
      setMonth('');
      setDay('');
    }
  }, [birthday]);

  useEffect(() => {
    if (year && month && correctedDay) {
      onChangedBody(target, `${year}年${month}月${correctedDay}日`);
    }
  }, [year, month, day]);

  const handleChange = (name: 'year' | 'month' | 'day', value: string) => {
    if (name === 'year') setYear(value);
    if (name === 'month') setMonth(value);
    if (name === 'day') setDay(value);
  };

  const yearList = Array.from({ length: 91 }, (_, i) => String(new Date().getFullYear() - 90 + i));
  const monthList = Array.from({ length: 12 }, (_, i) => String(i + 1));

  return (
    <Presentation
      year={year}
      month={month}
      day={day}
      onChange={handleChange}
      yearList={yearList}
      monthList={monthList}
      dayList={dayOptions}
     />
  );
};
